<template>
  <div class="common-footer">
    <div class="logo_block">
      <div class="double-flex">
        <div class="sub_title">
          カテゴリ
          <span>category</span>
        </div>
        <ShadowButton
          class="shadow-button pc"
          :text="t('ポケモン')"
          :textLeft="true"
          @handleShadowBtnClick="goToPokemon"
        />
        <ShadowButton
          class="shadow-button"
          :text="t('ワンピース')"
          :textLeft="true"
          @handleShadowBtnClick="goToOnePiece"
        />
        <ShadowLink
          class="shadow-link"
          :text="t('オリパレットコラム')"
          :textLeft="true"
          href="https://oripalette.jp/media/"
          target="_blank"
        />
      </div>
      <div class="double-flex">
        <div class="sub_title">
          オリパレットについて
          <span>about</span>
        </div>
        <ShadowButton
          class="shadow-button pc"
          :text="t('運営会社')"
          :textLeft="true"
          @handleShadowBtnClick="goToPubUrl"
        />
        <ShadowButton
          class="shadow-button"
          :text="t('利用規約')"
          :textLeft="true"
          @handleShadowBtnClick="goToTermsOfService"
        />
        <ShadowButton
          class="shadow-button"
          :text="t('お問い合わせ/よくある質問')"
          :textLeft="true"
          @handleShadowBtnClick="goToUserGuide"
        />
        <ShadowButton
          class="shadow-button pc"
          :text="t('プライバシーポリシー')"
          :textLeft="true"
          @handleShadowBtnClick="goToPrivacyProtection"
        />
        <ShadowButton
          class="shadow-button pc"
          :text="t('特定商取引法に基づく表記')"
          :textLeft="true"
          @handleShadowBtnClick="goToSpecificCommerce"
        />
        <ShadowButton
          class="shadow-button"
          :text="t('当選報告')"
          :textLeft="true"
          @handleShadowBtnClick="goTousenHoukoku"
        />
        <ShadowButton
          class="shadow-button"
          :text="t('メディア掲載実績')"
          :textLeft="true"
          @handleShadowBtnClick="goMediaList"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import DoubleBorderBox from '@/components/molecules/DoubleBorderBox.vue';
import ShadowButton from '@/components/molecules/ShadowButton.vue';
import ShadowLink from '@/components/molecules/ShadowLink.vue';
import t from '@/plugins/i18n';

export default {
  name: 'CommonFooter',

  components: {
    // DoubleBorderBox,
    ShadowButton,
    ShadowLink,
  },

  props: {
    currentUser: {
      type: Object,
    },
  },
  mixins: [t],

  methods: {
    goToLogin() {
      // ログインしていない場合、ログイン画面へ。routerのbeforeEachだとエラーが出る。（リダイレクトはされる）
      const query = {
        packId: this.$route.query.packId,
      };
      this.$router.push({
        path: '/login',
        query: this.$route.query.packId ? query : null,
      });
    },
    goToTop() {
      if (this.$route.name === 'Top') {
        return;
      }
      this.$router.push('/');
    },
    goToMyPage() {
      if (this.$route.name === 'MyPage') {
        return;
      }
      if (this.currentUser.is_login === '0') {
        if (this.$route.name === 'UserLogin') {
          return;
        }
        this.goToLogin();
        return;
      }
      this.$router.push('/my-page');
    },
    goToBuyPoint() {
      if (this.$route.name === 'BuyPoint') {
        return;
      }
      if (this.currentUser.is_login === '0') {
        if (this.$route.name === 'UserLogin') {
          return;
        }
        this.goToLogin();
        return;
      }
      let url = '/buy-point';
      if (this.$route.params.productId) {
        url += `/${this.$route.params.productId}`;
      }
      this.$router.push(url);
    },
    goToBuyProductHistory() {
      if (this.$route.name === 'BuyProductHistory') {
        return;
      }
      if (this.currentUser.is_login === '0') {
        if (this.$route.name === 'UserLogin') {
          return;
        }
        this.goToLogin();
        return;
      }
      this.$router.push('/buy-product-history');
    },
    goToSpecificCommerce() {
      // this.$router.push('/specific-commerce');
      window.open('/notation/', '_blank');
    },
    goToTermsOfService() {
      // this.$router.push('/terms-of-service');
      window.open('/terms/', '_blank');
    },
    goToPrivacyProtection() {
      // this.$router.push('/privacy-protection');
      window.open('/policy/', '_blank');
    },
    goToUserGuide() {
      // this.$router.push('/user-guide');
      window.open('/user-guide/', '_blank');
    },
    goContactUs() {
      window.open('https://tuuube.jp/contact-oripalette/', '_blank');
    },
    goTousenHoukoku() {
      window.open('https://oripalette.jp/report/', '_blank');
    },
    goToPubUrl() {
      window.open('https://tuuube.jp/company/');
    },
    goMediaList() {
      window.open('https://oripalette.jp/introduced/');
    },
    goToPokemon() {
      if (this.$route.name !== 'Top') {
        this.$router.push('/');
      }
      this.$store.dispatch('pack/setTopCardType', 1);
      window.scrollTo(0, 0);
    },
    goToOnePiece() {
      if (this.$route.name !== 'Top') {
        this.$router.push('/');
      }
      this.$store.dispatch('pack/setTopCardType', 2);
      window.scrollTo(0, 0);
    },

  },
};
</script>

<style lang="scss" scoped>
.common-footer {
  background-color: #353e59;
  margin-top: 40px;
  padding-bottom: 40px;
  .double-flex {
    padding: 20px;
    color: $white;
    .shadow-button,
    .shadow-link {
      margin: 5px 5px;
      display: flex;
      &::before {
        content: '▶︎';
        margin-right: 5px;
        font-size: 7px;
        display: flex;
        align-items: center;
      }
    }
    .sub_title {
      border-bottom: 1px solid #a8acb8;
      padding-left: 5px;
      padding-right: 20px;
      font-size: 16px;
      span {
        color: #464f68;
        font-size: 12px;
      }
    }
  }
  .footer-button-area {
    display: none;
  }
  .logo_block {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-left: 15%;
    .logo {
      img {
        width: 180px;
      }
    }
  }
}
.footer {
  background-color: #353e59;
  color: #fff;
  text-align: center;
  font-size: 12px;
  padding: 0 0 20px 0;
}
.pc {
  display: block;
}
.sp {
  display: none;
}
@media screen and (max-width: $tabletWidth) {
  .common-footer{
    .double-flex {
      padding: 20px 20px;
      .shadow-button,
      .shadow-link {
        width: 100%;
        margin: 10px 0;
        color: $white;
        font-size: 12px;
      }
      .sub_title {
        font-size: 12px;
      }
    }
    .logo_block {
      margin-left: 0;
      .logo {
        img {
          width: 150px;
        }
      }
    }
  }
}
</style>
